import { render, staticRenderFns } from "./ComGoodsSonConfig.vue?vue&type=template&id=73c7593a&scoped=true&"
import script from "./ComGoodsSonConfig.vue?vue&type=script&lang=js&"
export * from "./ComGoodsSonConfig.vue?vue&type=script&lang=js&"
import style0 from "./ComGoodsSonConfig.vue?vue&type=style&index=0&id=73c7593a&prod&lang=css&"
import style1 from "./ComGoodsSonConfig.vue?vue&type=style&index=1&id=73c7593a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c7593a",
  null
  
)

export default component.exports